/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useEffect, useState } from "react";
import { APIGET } from '../../services/APIServices';
import Loading from '../../images/Table/Loading.gif';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import ThemeControls from "../AllThemesControl";
import FormScopeDefiner from "./FormScopeDefiner";
const apiContextVar='';
function EditForm(props) {
  const {
    contextJson,
    contextHeading,
    formFieldsJson,
    close,
    apiPath,
    index,
    dataArr,
    apiContextObj
  } = props;
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const navigate = useNavigate();
  const [editData, setEditData] = useState([]);
  const contextObjective = "update";
  const contextIndex = index;
  const [contextDataArr, setContextDataArr] = useState(dataArr);
  const [editFOpen, setEditFOpen] = useState(false);
  function fetchEditData(apiContext, id) {
    if (typeof apiContext === 'string') {
      fetchData(apiContext, "/all", id);
    } else if (Array.isArray(apiContext)) {
      const promises = apiContext.map((item) => {
        if (item.apiContext && item.type && item.id) {
          return fetchData(item.apiContext, item.type, dataArr[index][id], item.id);
        }
        return Promise.resolve(null);
      });

      Promise.all(promises)
        .then(() => {
          setEditFOpen(true);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
       
    }
  }

  async function fetchData(apiContextVar, type, id, arryId) {
    try {
      const response = await APIGET(`${apiContextVar}${type}${id}`);
      if (response) {
        const apiResponseData = response.data;
        response[apiContextVar] = apiResponseData;
        // setEditData((prevData) => [...prevData, apiResponseData]);
        setEditData(apiResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  //console.log(editData)

  useEffect(() => {
   if(contextIndex!==undefined&&editData.length!==0){
    if (Array.isArray(editData)) {
      // This code block will execute if editData is an object
      Object.keys(formFieldsJson).forEach((key) => {
        if (key === "Parameter_Billing" && formFieldsJson[key].fields) {
         
          mapFields(formFieldsJson[key].fields, editData[0],{});

        }
      });
    } else if (typeof editData === 'object') {
      // This code block will execute if editData is an array
      Object.keys(formFieldsJson).forEach((key) => {
        if (key !== "xioFEConfig" && key !== "Parameter_Billing" && formFieldsJson[key].fields) {
        
          mapFields(formFieldsJson[key].fields, editData, apiContextObj.id);

        }
      });
    }
   }
  }, [contextIndex,editData]);


  useEffect(() => {
    fetchEditData(apiContextObj.editFlow.apiContextGet, apiContextObj.id);
  }, []);

  function mapFields(fields, data, idKey) {
    fields.forEach((field) => {
      field.field_value = data[field.field_id];
      field.id = data[idKey] || field.id; // Use field.id if data[idKey] is undefined
    });
  }

  return (
    <>
      <div className={classes.close}>
        <CloseIcon onClick={close} />
        <h4>Edit {contextHeading}</h4>
      </div>
      <div className={classes.preview}>
        {editFOpen ? (
          <div className={classes.pt}>
            <FormScopeDefiner value={{editData, close, contextJson, apiContextObj,  contextObjective, contextIndex, contextDataArr }}></FormScopeDefiner>
          </div>
        ) : (
          <div className={classes.loader}>
            <img src={Loading} alt="Loading..." />
          </div>
        )}
      </div>
    </>
  );
}

export default EditForm;



// import React, { useEffect, useState } from "react";
// import { APIGET } from '../../services/APIServices';
// import Loading from '../../images/Table/Loading.gif';
// import CloseIcon from '@mui/icons-material/Close';
// import { useNavigate } from "react-router-dom";
// import ThemeControls from "../AllThemesControl";
// import FormScopeDefiner from "./FormScopeDefiner";
// import { useLocation,useParams } from 'react-router-dom';

// function EditForm(props) {
//   const { id } = useParams();
//   const location = useLocation();
//   const receivedData = location.state;
//   const {
//     contextJson,
//     contextHeading,
//     formFieldsJson,
//     close,
//     apiPath,
//     index,
//     dataArr,
//     apiContextObj
//   } = receivedData;
//   const { useStyles } = ThemeControls;
//   const classes = useStyles();
//   const navigate = useNavigate();
//   const [editData, setEditData] = useState([]);
//   const contextObjective = "update";
//   const contextIndex = index;
//   const [contextDataArr, setContextDataArr] = useState(dataArr);
//   const [editFOpen, setEditFOpen] = useState(false);
 
//   //console.log(apiContextObj)

//   function fetchEditData(apiContext, id) {
//     if (typeof apiContext === 'string') {
//       fetchData(apiContext, "/all", id);
//     } else if (Array.isArray(apiContext)) {
//       const promises = apiContext.map((item) => {
//         if (item.apiContext && item.type && item.id) {
//           return fetchData(item.apiContext, item.type, id, item.id);
//         }
//         return Promise.resolve(null);
//       });

//       Promise.all(promises)
//         .then(() => {
//           setEditFOpen(true);
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//         });
//     } else {
 
//     }
//   }

//   async function fetchData(apiContextVar, type, id, arryId) {
//     try {
//       const response = await APIGET(`${apiContextVar}${type}${id}`);
//       if (response) {
//         const apiResponseData = response.data;
//         response[apiContextVar] = apiResponseData;
//         // setEditData((prevData) => [...prevData, apiResponseData]);
//         setEditData(apiResponseData);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   }
//   //console.log(editData)

//   useEffect(() => {
//    if(editData.length!==0){
//     if (Array.isArray(editData)) {
//       // This code block will execute if editData is an object
//       Object.keys(formFieldsJson).forEach((key) => {
//         if (key === "Parameter_Billing" && formFieldsJson[key].fields) {
         
//           mapFields(formFieldsJson[key].fields, editData[0],{});

//         }
//       });
//     } else if (typeof editData === 'object') {
//       // This code block will execute if editData is an array
//       Object.keys(formFieldsJson).forEach((key) => {
//         if (key !== "xioFEConfig" && key !== "Parameter_Billing" && formFieldsJson[key].fields) {
       
//           mapFields(formFieldsJson[key].fields, editData, apiContextObj.id);

//         }
//       });
//     }
//    }
//   }, [editData]);


//   useEffect(() => {
//     fetchEditData(apiContextObj.apiContextGetById, id);
//   }, []);

//   function mapFields(fields, data, idKey) {
//     fields.forEach((field) => {
//       field.field_value = data[field.field_id];
//       field.id = data[idKey] || field.id; // Use field.id if data[idKey] is undefined
//     });
//   }

//   return (
//     <>
//       {/* <div className={classes.close}>
//         <CloseIcon onClick={close} />
//         <h4>Edit {contextHeading}</h4>
//       </div> */}
//       <div className={classes.preview}>
//         {editFOpen ? (
//           <div className={classes.pt}>
//             <FormScopeDefiner value={{ editData, close, contextJson, apiContextObj,  contextObjective, contextIndex, contextDataArr }}></FormScopeDefiner>
//           </div>
//         ) : (
//           <div className={classes.loader}>
//             <img src={Loading} alt="Loading..." />
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default EditForm;
